	export enum DocumentTemplateTypeEnum {
		Appointment = 1,
		Patient = 3,
		QuotesAndInvoices = 4,
		ReferringPhysicianLetter = 5,
		Outreach = 6,
		InventoryOrder = 7,
		SmsTemplate = 8,
		ClaimFileLabel = 9
	}
